import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';
import { StudyData } from '@/types/study';

const fetchStudy = async (studyId: string): Promise<StudyData> => {
  const response = await API.authenticated.fetch(`/studies/${studyId}`);

  if (!response.ok) {
    throw new Error('Failed to fetch study');
  }

  return response.json();
};

export const useStudy = (studyId: string) =>
  useQuery({
    queryKey: ['study', studyId],
    queryFn: () => fetchStudy(studyId),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
